'use client';

import { c as _c } from "react/compiler-runtime";
import type { AnalyticsSkuViewedProps } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import { useCardPosition } from 'src/features/roundup-filters/CardPositionContext';
import { useFiltersDialogContext } from 'src/features/roundup-filters/Mobile/components/FiltersDialogContext';
export function FilterAwareSkuViewed(props) {
  const $ = _c(4);
  const {
    isMobileFiltersDialogOpen
  } = useFiltersDialogContext();
  const impressionPosition = useCardPosition(props.impressionPosition);
  const t0 = !isMobileFiltersDialogOpen;
  let t1;
  if ($[0] !== impressionPosition || $[1] !== props || $[2] !== t0) {
    t1 = <AnalyticsSkuViewed {...props} enabled={t0} impressionPosition={impressionPosition} />;
    $[0] = impressionPosition;
    $[1] = props;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}